const faqs = [
  {
    question: "What is a CSSBuy spreadsheet?",
    answer: "A CSSBuy spreadsheet is a curated directory of verified seller links organized by product categories. These spreadsheets help shoppers using CSSBuy (a popular shopping agent) quickly find trusted sellers for shoes, clothing, accessories, and more without having to search through forums or unverified sources.",
  },
  {
    question: "How do I use the category links on this site?",
    answer: "Each category link on CSSSpreadsheet.cam directs you to a curated spreadsheet page on kaspreadsheet.com. Simply click the category you are interested in — Shoes, Hoodies, Jackets, Bags, or any other category — and you will be taken to a verified list of seller links for that product type.",
  },
  {
    question: "Are all the seller links verified?",
    answer: "Yes. Every spreadsheet link shared through this directory is manually reviewed and regularly updated. We prioritize quality over quantity to ensure you are browsing reliable seller information rather than outdated or scam links.",
  },
  {
    question: "Is CSSSpreadsheet.cam free to use?",
    answer: "Completely free. There are no sign-ups, subscriptions, or hidden fees. CSSSpreadsheet.cam is a public resource directory built to help the shopping agent community find trusted CSSBuy spreadsheet resources quickly and easily.",
  },
  {
    question: "Does this site support other shopping agents like Kakobuy or Superbuy?",
    answer: "While our primary focus is CSSBuy spreadsheets, many of the seller links and categories are also compatible with other popular shopping agents including Kakobuy, Superbuy, and Oopbuy. The product links work across platforms as long as you use the correct agent.",
  },
  {
    question: "How often are the spreadsheets updated?",
    answer: "Our directory is maintained regularly with weekly checks on link validity and seller status. We remove broken links, add new verified sellers, and update category organization to keep the resource fresh and reliable.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-base text-foreground-600">
            Everything you need to know about CSSBuy spreadsheets and our resource directory
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer select-none">
                <span className="text-sm font-semibold text-foreground-800 pr-6">
                  {faq.question}
                </span>
                <i className="ri-add-line text-foreground-400 group-open:hidden text-lg flex-shrink-0"></i>
                <i className="ri-subtract-line text-foreground-400 hidden group-open:block text-lg flex-shrink-0"></i>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}